<ion-app [class.dark-theme]="dark">
  <ion-split-pane contentId="main-content">

    <ion-menu contentId="main-content">
      <ion-content>
        <ion-list lines="none" *ngIf="loggedIn">
          <ion-list-header>
            <!-- <ion-icon src="assets/img/icon/acuplace.svg" color="primary" size="large" item-start></ion-icon> -->
            <ion-label>Acuplace <ion-badge *ngIf="isCollaudo" style="--background: #9c27b0; font-size: 0.75em; vertical-align: middle; margin-left: 5px;">BETA</ion-badge></ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false" *ngFor="let p of appPages; let i = index">
            <ion-item [routerLink]="p.url" routerLinkActive="selected" routerDirection="root" detail="false">
              <ion-icon slot="start" [name]="p.icon + '-outline'"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>

          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false" *ngIf="loggedIn">
            <ion-item routerLink="/jira" routerLinkActive="active" routerDirection="root" detail="false"
              *ngIf="roleService.hasJIRA()">
              <ion-icon slot="start" name="logo-bitbucket"></ion-icon>
              <ion-label>
                Jira
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false" *ngIf="loggedIn && roleService.hasHRorAdmin()">
            <ion-item routerLink="/analytics" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="bar-chart-outline"></ion-icon>
              <ion-label>
                Analytics Presenze
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false" *ngIf="loggedIn && roleService.hasHRorManager()">
            <ion-item routerLink="/eventi" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="megaphone-outline"></ion-icon>
              <ion-label>
                Eventi Aziendali
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <ion-list lines="none">
          <ion-list-header>
            Configurazioni
          </ion-list-header>
          <ion-menu-toggle autoHide="false" *ngIf="loggedIn && roleService.hasHRorAdmin()">
            <ion-item routerLink="/richieste-sede" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="key-outline"></ion-icon>
              <ion-label>
                Richieste abilitazione sedi
              </ion-label>
              <ion-badge slot="end" color="danger" *ngIf="richiesteSedeStore.daGestire.length > 0">{{ richiesteSedeStore.daGestire.length }}</ion-badge>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false" *ngIf="loggedIn && roleService.hasHRorAdmin()">
            <ion-item routerLink="/administrator" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>
              <ion-label>
                Amministrazione
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false" *ngIf="loggedIn">
            <ion-item routerLink="/configuration" routerLinkActive="active" routerDirection="root" detail="false"
              *ngIf="roleService.hasHRorAdmin()">
              <ion-icon slot="start" name="options-outline"></ion-icon>
              <ion-label>
                Sedi e uffici
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false">
            <ion-item>
              <ion-icon slot="start" name="accessibility-outline"></ion-icon>
              <ion-label>
                Accessibilità
              </ion-label>
              <ion-toggle [(ngModel)]="accessibility" (ionChange)="changeAccessibility($event)"></ion-toggle>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false">
            <ion-item>
              <ion-icon slot="start" name="moon-outline"></ion-icon>
              <ion-label>
                Dark Mode
              </ion-label>
              <ion-toggle [(ngModel)]="dark" (ionChange)="changeTheme($event)"></ion-toggle>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list lines="none">
          <ion-list-header>
            Support
          </ion-list-header>

          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="help"></ion-icon>
              <ion-label>
                Support
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false" *ngIf="loggedIn && enableFeedbackOnDemand">
            <ion-item button (click)="openFeedbackModal('menu_laterale')" detail="false">
              <ion-icon slot="start" name="chatbox-ellipses-outline"></ion-icon>
              <ion-label>
                Lascia un parere
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false" *ngIf="loggedIn && roleService.hasAdmin() && enableFeedbackDashboard">
            <ion-item routerLink="/feedback-dashboard" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="star-half-outline"></ion-icon>
              <ion-label>
                Feedback Dashboard
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false" *ngIf="loggedIn">
            <ion-item button (click)="openTutorial()" detail="false">
              <ion-icon slot="start" name="book-outline"></ion-icon>
              <ion-label>Manuale Utente</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <!-- <ion-menu-toggle autoHide="false">
            <ion-item button (click)="logout()" detail="false">
              <ion-icon slot="start" name="log-out"></ion-icon>
              <ion-label>
                Logout
              </ion-label>
            </ion-item>
          </ion-menu-toggle> -->

        </ion-list>

        <ion-list lines="none" *ngIf="loggedIn && showInstallBtn">
          <ion-menu-toggle autoHide="false">
            <ion-item button (click)="installPwa()" detail="false">
              <ion-icon slot="start" name="download-outline"></ion-icon>
              <ion-label>Installa Acuplace</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list lines="none" *ngIf="!loggedIn">
          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/login" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="log-in"></ion-icon>
              <ion-label>
                Login
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list lines="none" *ngIf="loggedIn">
          <ion-menu-toggle autoHide="false">
            <ion-button class="ion-padding" (click)="logout()" expand="block" color="primary">
              <ion-icon slot="start" name="log-out"></ion-icon>
              Logout
            </ion-button>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>

  </ion-split-pane>

  <acu-qa-widget *ngIf="enableQaHelper"></acu-qa-widget>

  <!-- Global On-Demand Feedback Modal -->
  <acu-feedback
    *ngIf="feedbackModalState.isOpen"
    [context]="feedbackModalState.context"
    (feedbackDone)="onFeedbackModalDone()"
  ></acu-feedback>

  <!-- Floating PWA Install Banner -->
  <div class="pwa-install-banner" *ngIf="showInstallBanner && loggedIn" [class.is-collaudo]="isCollaudo">
    <div class="pwa-banner-card">
      <div class="pwa-banner-header">
        <div class="pwa-banner-media">
          <img [src]="isCollaudo ? 'assets/img/android-chrome-192x192-collaudo.png' : 'assets/img/android-chrome-192x192.png'" alt="Acuplace Icon" class="pwa-banner-icon" />
        </div>
        <div class="pwa-banner-body">
          <div class="pwa-banner-title">
            <span>{{ isCollaudo ? 'Installa Acuplace Beta' : 'Installa Acuplace' }}</span>
            <ion-badge [color]="isCollaudo ? 'tertiary' : 'primary'">APP</ion-badge>
          </div>
          <p class="pwa-banner-desc" *ngIf="!isIosPrompt">
            Aggiungi Acuplace alla schermata Home per aprirla a schermo intero e accedere in un attimo.
          </p>
          <p class="pwa-banner-desc" *ngIf="isIosPrompt">
            Tocca l'icona Condividi <ion-icon name="share-outline"></ion-icon> e scegli <strong>"Aggiungi alla schermata Home"</strong>.
          </p>
        </div>
        <button type="button" class="pwa-banner-close" (click)="dismissInstallBanner()" aria-label="Chiudi banner">
          <ion-icon name="close"></ion-icon>
        </button>
      </div>

      <div class="pwa-banner-actions" *ngIf="!isIosPrompt">
        <ion-button fill="solid" [color]="isCollaudo ? 'tertiary' : 'primary'" size="small" class="pwa-action-install" (click)="installPwa()">
          <ion-icon slot="start" name="download-outline"></ion-icon>
          Installa ora
        </ion-button>
        <ion-button fill="clear" color="medium" size="small" class="pwa-action-dismiss" (click)="dismissInstallBanner()">
          Non ora
        </ion-button>
      </div>

      <div class="pwa-banner-actions" *ngIf="isIosPrompt">
        <ion-button fill="solid" [color]="isCollaudo ? 'tertiary' : 'primary'" size="small" class="pwa-action-install" (click)="dismissInstallBanner()">
          <ion-icon slot="start" name="checkmark-outline"></ion-icon>
          Ho capito
        </ion-button>
      </div>
    </div>
  </div>
</ion-app>